import request from '@/utils/request'

// 查询用户ip接口
export function getUserIp() {
  return request({
    url: '/user/getUserIp',
    method: 'get',
  })
}

// 修改默认级距
export function updatePriorityGroup(id, params) {
  return request({
    url: `/user/updatePriorityGroup/${id}`,
    method: 'post',
    params,
  })
}

// 清除指定用户快取
export function clearCache(data) {
  return request({
    url: '/user/clearCache',
    method: 'post',
    data,
  })
}

// 通道型代理是否启用兑换
export function updateChannelAgentEnableWithdraw(id, data) {
  return request({
    url: `/user/updateChannelAgentEnableWithdraw/${id}`,
    method: 'post',
    data,
  })
}

// 替換代理上級
export function changeAgentSuperior(data) {
  return request({
    url: '/user/changeAgentSuperior',
    method: 'post',
    data,
  })
}

// 凭证审核员转移未处理订单给其他审核员
export function dynamicAssignOrders(id) {
  return request({
    url: `/user/dynamicAssignOrders/${id}`,
    method: 'post',
  })
}

// 修改凭证审核员上线状况
export function updateCredentialAuditorOnlineStatus(data) {
  return request({
    url: '/user/updateCredentialAuditorOnlineStatus',
    method: 'post',
    data,
  })
}

// 修改卡主上线状况
export function updateCustomerOnlineStatus(data) {
  return request({
    url: '/user/updateCustomerOnlineStatus',
    method: 'post',
    data,
  })
}

// 更新用户是否为车队
export function updateCaptain(id, data) {
  return request({
    url: `/user/updateCaptain/${id}`,
    method: 'post',
    data,
  })
}

// 获取user新配置角色中被禁用角色列表
export function checkDisableRolesInNewAllocation(params) {
  return request({
    url: '/user/role/checkDisableRolesInNewAllocation',
    method: 'get',
    params,
  })
}

// 获取用户类型列表
export function userTypeList() {
  return request({
    url: '/user/userTypeList',
    method: 'get',
  })
}

// 替换旗下代理与卡主
export function transferAgent(data) {
  return request({
    url: '/user/transferAgent',
    method: 'post',
    data: data,
    timeout: 300000, // 1000 * 60 * 5(五分钟)
  })
}

// 財務批次申請提現余額
export function batchApplyWithdrawBalance(data) {
  return request({
    url: '/user/withdraw/batchApplyWithdrawBalance',
    method: 'post',
    data: data,
  })
}

// 转移卡主所有银行卡
export function transferUserAllBankAccount(data) {
  return request({
    url: '/account/bank/transferUserAllBankAccount',
    method: 'post',
    data: data,
  })
}

// 替换卡主的代理功能
export function changeAgent(data) {
  return request({
    url: '/user/changeAgent',
    method: 'post',
    data: data,
  })
}

// 取消分配用戶組
export function unassignGroup(data) {
  return request({
    url: '/user/group/unassignGroup',
    method: 'post',
    data: data,
  })
}

// 分配用户组
export function assignGroup(data) {
  return request({
    url: '/user/group/assignGroup',
    method: 'post',
    data: data,
  })
}

// 用户组列表
export function listGroupUsers(groupName) {
  return request({
    url: `/user/group/listGroupUsers/${groupName}`,
    method: 'get',
  })
}

// 用户全部分组
export function allGroup() {
  return request({
    url: '/user/group/allGroup',
    method: 'get',
  })
}

// 佣金转积分
export function commissionToJifen(data) {
  return request({
    url: '/user/withdraw/commissionToJifen',
    method: 'post',
    data: data,
  })
}

// 积分转佣金
export function jifenToBalance(data) {
  return request({
    url: '/user/jifen/jifenToBalance',
    method: 'post',
    data: data,
  })
}

// 模拟登录
export function imitationLogin(data) {
  return request({
    url: '/user/imitationLogin',
    method: 'post',
    data: data,
  })
}

// 取得商户列表
export function userNameList(params) {
  return request({
    url: '/user/userNameList',
    method: 'get',
    params: params,
  })
}

// 用户上下线记录
export function loginRecordList(params) {
  return request({
    url: '/user/loginRecordList',
    method: 'get',
    params: params,
  })
}

// 调整积分余额
export function adjustJifenBalance(data) {
  return request({
    url: '/user/jifen/adjustJifenBalance',
    method: 'post',
    data: data,
  })
}

export function agentRecycel(data) {
  return request({
    url: '/user/jifen/agent/recycle',
    method: 'post',
    data: data,
  })
}

export function agentTopup(data) {
  return request({
    url: '/user/jifen/agent/topUp',
    method: 'post',
    data: data,
  })
}

export function replacePayPassword(data) {
  return request({
    url: '/user/replacePayPassword',
    method: 'post',
    data: data,
  })
}

export function updatePayPassword(data) {
  return request({
    url: '/user/updatePayPassword',
    method: 'post',
    data: data,
  })
}

export function replacePassword(data) {
  return request({
    url: '/user/replacePassword',
    method: 'post',
    data: data,
  })
}

export function getOrderFeeDetailList(params) {
  return request({
    url: '/user/record/orderFeeDetailList',
    method: 'get',
    params: params,
  })
}

export function getJifenBalanceChangeDetailList(params) {
  return request({
    url: '/user/record/jifenBalanceChangeDetailList',
    method: 'get',
    params: params,
  })
}

export function getBalanceChangeDetailList(params) {
  return request({
    url: '/user/record/balanceChangeDetailList',
    method: 'get',
    params: params,
  })
}

export function updatePassword(data) {
  return request({
    url: '/user/updatePassword',
    method: 'post',
    data: data,
  })
}

export function clearVerifyCode(id) {
  return request({
    url: `/user/clearVerifyCode/${id}`,
    method: 'patch',
  })
}

export function status(data) {
  return request({
    url: `/user/updateStatus/${data.id}`,
    method: 'post',
    params: {
      status: data.status
    },
  })
}

// PAY-1899 SIM卡异常禁用, 针对卡主新增SIM卡侦测开通白名
export function updateSimCardMonitorStatus(data) {
  return request({
    url: `/user/updateSimCardMonitorStatus/${data.id}`,
    method: 'post',
    params: {
      enable: data.isIgnoreSimCardMonitor
    },
  })
}

export function editUser(data) {
  return request({
    url: `/user/update/${data.id}`,
    method: 'post',
    data: data,
  })
}

// PAY-1583
export function editUserBF(data) {
  return request({
    url: `/user/updateBF/${data.id}`,
    method: 'post',
    data: data,
  })
}

export function editUserRole(params) {
  return request({
    url: '/user/role/update',
    method: 'post',
    params,
  })
}

export function getUserRole(id) {
  return request({
    url: `/user/role/${id}`,
    method: 'get',
  })
}

// 添加卡主
export function addKefu(data) {
  return request({
    url: '/user/addKefu',
    method: 'post',
    data: data,
  })
}

export function addAdmin(data) {
  return request({
    url: '/user/addAdmin',
    method: 'post',
    data: data,
  })
}

export function addAgent(data) {
  return request({
    url: '/user/addAgent',
    method: 'post',
    data: data,
  })
}

// 添加代理助理
export function addAgentAssistant(data) {
  return request({
    url: '/user/addAgentAssistant',
    method: 'post',
    data: data,
  })
}

// 添加指定代理助理
export function addAssignAgentAssistant(id, data) {
  return request({
    url: `/user/addAssignAgentAssistant/${id}`,
    method: 'post',
    data: data,
  })
}

// 添加凭证审核员
export function addCredentialAuditor(data) {
  return request({
    url: '/user/addCredentialAuditor',
    method: 'post',
    data: data,
  })
}

export function addCustomer(data) {
  return request({
    url: '/user/addCustomer',
    method: 'post',
    data: data,
  })
}

export function addFinance(data) {
  return request({
    url: '/user/addFinance',
    method: 'post',
    data: data,
  })
}

export function addSeller(data) {
  return request({
    url: '/user/addSeller',
    method: 'post',
    data: data,
  })
}

export function addOperator(data) {
  return request({
    url: '/user/addOperator',
    method: 'post',
    data: data,
  })
}

// 新增操作员管理员
export function addOperatorAdmin(data) {
  return request({
    url: '/user/addOperatorAdmin',
    method: 'post',
    data: data,
  })
}

// 新增查单值机
export function addSwitchboard(data) {
  return request({
    url: '/user/addSwitchboard',
    method: 'post',
    data: data,
  })
}

// 新增短信模版管理员
export function addSmsAdmin(data) {
  return request({
    url: '/user/addSmsAdmin',
    method: 'post',
    data: data,
  })
}

// export function addUser(data) {
//   return request({
//     url: '/user/addUser',
//     method: 'post',
//     data: data,
//   })
// }

export function getUserTypeList() {
  return request({
    url: '/user/type',
    method: 'get',
  })
}

export function getUserList(params) {
  return request({
    url: '/user/list',
    method: 'get',
    params: params,
  })
}

export function getUserById(id) {
  return request({
    url: `/user/${id}`,
    method: 'get',
  })
}

// 提交APP服务申请
export function sendRequestApp(data) {
  return request({
    url: '/user/sendRequestApp',
    method: 'post',
    data: data,
  })
}

// 修改共享积分开关
export function updateSwitchShareJifen(data) {
  return request({
    url: `/user/jifen/updateSwitchShareJifen/${data.id}`,
    method: 'post',
    params: {
      switchShareJifen: data.switchShareJifen
    },
  })
}

// 控制操作员上下线
export function updateOperatorOnlineStatus(data) {
  return request({
    url: '/user/updateOperatorOnlineStatus',
    method: 'post',
    data: data,
  })
}

// 获取用户名称列表
export function getUserNameList(params) {
  return request({
    url: '/user/userNameList',
    method: 'get',
    params: params,
  })
}

// 系统管理员禁用
export function adminDisable(id, data) {
  return request({
    url: `/user/adminDisable/${id}`,
    method: 'post',
    data: data,
  })
}

// 系统管理员群禁用
export function adminDisableAllLowerLevel(id, data) {
  return request({
    url: `/user/disable/allLowerLevel/${id}`,
    method: 'post',
    data: data,
  })
}

// 调整积分余额
export function adjustJifenBalanceFromPayForceComplete(data) {
  return request({
    url: `/user/jifen/adjustJifenBalanceFromPayForceComplete`,
    method: 'post',
    data: data,
  })
}

/* ------ Fee Start ------ */
// 添加押金设定
export function addFeeDepositLevel(data) {
  return request({
    url: `/user/fee/depositLevel/create`,
    method: 'post',
    data: data,
  })
}
// 押金设定列表
export function getFeeDepositLevel(params) {
  return request({
    url: `/user/fee/depositLevel/list`,
    method: 'get',
    params,
  })
}
// 修改押金设定
export function updateFeeDepositLevel(data) {
  return request({
    url: `/user/fee/depositLevel/update/${data.id}`,
    method: 'put',
    data
  })
}

// 添加费率设定
export function addFeeFeeIntervalSetting(data) {
  return request({
    url: `/user/fee/feeIntervalSetting/create`,
    method: 'post',
    data: data,
  })
}
// 费率设定列表
export function getFeeIntervalSetting(params) {
  return request({
    url: `/user/fee/feeIntervalSetting/list`,
    method: 'get',
    params,
  })
}
// 修改费率设定
export function updateFeeIntervalSetting(data) {
  return request({
    url: `/user/fee/feeIntervalSetting/update/${data.id}`,
    method: 'put',
    data
  })
}

// 用户费率列表 全部用户通用
export function getFeeRateList(userId) {
  return request({
    url: `/user/fee/rate/list/${userId}`,
    method: 'get',
  })
}

// 批量修改一级代理费率
export function batchUpdateFirstAgent(userId, data) {
  return request({
    url: `/user/fee/rate/batchUpdate/FirstAgent/${userId}`,
    method: 'post',
    data,
  })
}

// 批量修改一般代理/卡主费率
export function batchUpdate(userId, data) {
  return request({
    url: `/user/fee/rate/batchUpdate/commonUser/${userId}`,
    method: 'post',
    data,
  })
}

//更新用户押金
export function updateDeposit(data) {
  return request({
    url: `/user/updateDeposit/${data.id}`,
    method: 'post',
    data,
  })
}

// 批量选择帐户费率
export function updateFeeRateBatchSelect(accId, data) {
  return request({
    url: `/user/fee/rate/batchSelect/${accId}`,
    method: 'put',
    data
  })
}

// 批量选择帐户费率 二维码版本
export function updateQRCodeFeeRateBatchSelect(accId, data) {
  return request({
    url: `/user/fee/qrcode/rate/batchSelect/${accId}`,
    method: 'put',
    data
  })
}
/* ------ Fee End ------ */

// 通道型代理是否关闭跑量
export function updateChannelAgentPayClosed(id, data) {
  return request({
    url: `/user/updateChannelAgentPayClosed/${id}`,
    method: 'post',
    data,
  })
}

// 代理、卡主上交积分给上一级
export function updateJifenAgentGiveUpper(data) {
  return request({
    url: `/user/jifen/agent/giveUpper`,
    method: 'post',
    data,
  })
}

// 查询被封锁IP记录
export function getBlockedIpList(params) {
  return request({
    url: '/user/getBlockedIpList',
    method: 'get',
    params,
  })
}

// 解除封锁IP
export function unblockIp(data) {
  return request({
    url: '/user/unblockIp',
    method: 'post',
    data: data,
  })
}

// 登出指定用户
export function logoutUser(data) {
  return request({
    url: '/user/logoutUser',
    method: 'delete',
    data: data,
  })
}

// 添加手动app卡主
export function addManualAppCustomer(data) {
  return request({
    url: '/user/addManualAppCustomer',
    method: 'post',
    data,
  })
}

// 添加手动非app卡主
export function addManualCustomer(data) {
  return request({
    url: '/user/addManualCustomer',
    method: 'post',
    data,
  })
}

// 添加客服管理员
export function addKefuAdmin(data) {
  return request({
    url: '/user/addKefuAdmin',
    method: 'post',
    data,
  })
}

// 手动app卡主列表
export function manualAppCustomerUserList(params) {
  return request({
    url: '/user/manualAppCustomerUserList',
    method: 'get',
    params,
  })
}

// 手动非app卡主列表
export function manualCustomerUserList(params) {
  return request({
    url: '/user/manualCustomerUserList',
    method: 'get',
    params,
  })
}

// 手动卡主申请提现
export function manualUserApplyWithdraw(data) {
  return request({
    url: '/user/withdraw/manualUserApplyWithdraw',
    method: 'post',
    data,
  })
}

// 獲取APP手机权限记录
export function getAppPermissionDetectRecord(params) {
  return request({
    url: `/user/record/appPermissionDetectRecord/${params.userId}`,
    method: 'get',
    params
  })
}

/* --- DSY-1155 --- */
// 新增用户组
export function addUserGroup(data) {
  return request({
    url: '/user/group/addUserGroup',
    method: 'post',
    data,
  })
}

// 用户组列表
export function listUserGroups(params) {
  return request({
    url: '/user/group/listUserGroups',
    method: 'get',
    params,
  })
}

// 删除用户组
export function delUserGroup(id) {
  return request({
    url: `/user/group/delUserGroup/${id}`,
    method: 'delete',
  })
}

// 更新用户组
export function updateUserGroup(id, data) {
  return request({
    url: `/user/group/updateUserGroup/${id}`,
    method: 'patch',
    data,
  })
}

// 获取用户组辨别符列表
export function listUserGroupIdentities() {
  return request({
    url: '/user/group/listUserGroupIdentities',
    method: 'get',
  })
}
/* --- End DSY-1155 --- */

// 获取客服名称列表
export function listKefuNames() {
  return request({
    url: '/user/listKefuNames',
    method: 'get',
  })
}

// 获取所有客服名称列表
export function listAllKefu() {
  return request({
    url: '/user/listAllKefu',
    method: 'get',
  })
}

// 获取客服名称列表
export function allSystemGroup() {
  return request({
    url: '/user/group/allSystemGroup',
    method: 'get',
  })
}

// 修改虚拟币充值奖励费率
export function updateCryptoTopUpBonusRate(id, data) {
  return request({
    url: `/user/updateCryptoTopUpBonusRate/${id}`,
    method: 'post',
    data
  })
}

// 查询积分、佣金快照
export function getUserJifenBalanceSnapshot(params) {
  return request({
    url: '/user/getUserJifenBalanceSnapshot',
    method: 'get',
    params,
  })
}

// 修改代理合并费率
export function agentMergeFee(id, data) {
  return request({
    url: `/user/fee/rate/agent/mergeFee/${id}`,
    method: 'post',
    data,
  })
}

/* --- 员工管理 ---  */
// 取得员工档资料
export function getEmployee(params) {
  return request({
    url: '/user/kefu/getEmployee',
    method: 'get',
    params
  })
}

// 取得全部员工档资料
export function getAllEmployee(params) {
  return request({
    url: '/user/kefu/getAllEmployee',
    method: 'get',
    params
  })
}

// 新增员工档
export function addEmployee(data) {
  return request({
    url: '/user/kefu/addEmployee',
    method: 'post',
    data,
  })
}

// 更新员工档
export function updateEmployee(data) {
  return request({
    url: `/user/kefu/updateEmployee/${data.employeeId}`,
    method: 'patch',
    data,
  })
}

// 删除员工档
export function deleteEmployee(employeeId) {
  return request({
    url: `/user/kefu/deleteEmployee/${employeeId}`,
    method: 'delete',
  })
}

/* --- 员工值班 API ---  */
// 取得员工值班历程
export function getEmployeeAttendance(params) {
  return request({
    url: '/user/kefu/getEmployeeAttendance',
    method: 'get',
    params
  })
}

// 开始员工值班
export function clockInEmployee(data) {
  return request({
    url: '/user/kefu/clockInEmployee',
    method: 'post',
    data,
  })
}

// 结束员工值班
export function clockOutEmployee(data) {
  return request({
    url: '/user/kefu/clockOutEmployee',
    method: 'post',
    data,
  })
}

// 取得当前员工值班状态
export function getEmployClockStatus(userId) {
  return request({
    url: `/user/kefu/getEmployClockStatus/${userId}`,
    method: 'get',
  })
}

// 取得客服处理狀態
export function getCustomerStatus(params) {
  return request({
    url: '/user/kefu/getCustomerStatus',
    method: 'get',
    params,
  })
}

// 禁提佣金/开放佣金
export function withdrawCommissionDisable(id, data) {
  return request({
    url: `/user/withdrawCommissionDisable/${id}`,
    method: 'post',
    data,
  })
}

// 回收佣金
export function recycleCommission(data) {
  return request({
    url: '/user/withdraw/recycleCommission',
    method: 'post',
    data,
  })
}

// 取得最新BF资料
export function getLatestBF(id) {
  return request({
    url: `/user/getLatestBF/${id}`,
    method: 'get',
  })
}

// 取得用户最低费率
export function getLowestFeeRate(userId) {
  return request({
    url: `/user/fee/rate/getLowestFeeRate/${userId}`,
    method: 'get',
  })
}

// 修改用户最低费率
export function updateLowestFeeRate(data) {
  return request({
    url: `/user/fee/rate/updateLowestFeeRate/${data.userId}`,
    method: 'post',
    data,
  })
}

// 管理员调整纯手动卡主押金
export function adjustManualCustomerCollateral(data) {
  return request({
    url: '/user/collateral/adjustManualCustomerCollateral',
    method: 'post',
    data,
  })
}

// 客服调整纯手动卡主押金
export function transferManualCustomerCollateral(data) {
  return request({
    url: '/user/collateral/transferManualCustomerCollateral',
    method: 'post',
    data,
  })
}

// 获取纯手动卡主押金账变列表
export function getManualCustomerCollateralChangeDetailList(params) {
  return request({
    url: '/user/collateral/getManualCustomerCollateralChangeDetailList',
    method: 'get',
    params,
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js